import { dateFormat } from '@/utils/dateFormat';

const commonFormatter = (v) => {
  if (!v && v !== 0) {
    return '--';
  }
  return v;
};
// 订单列表配置
export function setOrderTableColumns () {
  const orderTableColumns = [
    {
      title: '寄修单号',
      field: 'code',
      showOverflow: true,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let result = [];
          result = [
            h('span', {
              class: 'table-action',
              on: {
                click: () => {
                  this.handleShowDetail(row);
                },
              },
            }, row.code),
          ];
          return [h('span', result)];
        },
      },
    },
    {
      title: '供应商名称',
      field: 'tenantName',
      showOverflow: true,
      align: 'left',
    },
    {
      title: '创建人',
      field: 'createUserName',
      showOverflow: true,
      align: 'left',
    },
    {
      title: '创建时间',
      field: 'createTime',
      showOverflow: true,
      align: 'left',
      format: (cellValue) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '更新时间',
      field: 'lastUpdateTime',
      showOverflow: true,
      align: 'left',
      format: (cellValue) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '状态',
      field: 'statusMsg',
      showOverflow: true,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let actions = [];
          actions.push(
            <span class={['c_tag', row.status ? `status-${row.status}` : '']}>{row.statusMsg}</span>,
          );

          if (row.status === 8) {
            actions.push(
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  { row.closeReason }
                </div>
                <i class="el-icon-warning-outline" style="color: red; margin-left: 4px;"></i>,
              </el-tooltip>,
            );
          }

          return [h('div', actions)];
        },
      },
    },
    {
      title: '需求单号',
      field: 'requirementCode',
      showOverflow: true,
      align: 'left',
    },
    {
      title: '协同状态',
      field: 'syncStatus',
      showOverflow: true,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let actions = [];
          actions.push(
            <span>{row.syncStatus === 0 ? '未协同' : row.syncStatus === 1 ? '已协同' : row.syncStatus === 2 ? '协同失败' : ''}</span>,
          );

          if (row.syncStatus === 2) {
            actions.push(
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content">
                  { row.syncFailReason }
                </div>
                <i class="el-icon-warning-outline" style="color: red; margin-left: 4px;"></i>
              </el-tooltip>,
            );
          }

          return [h('div', actions)];
        },
      },
    },
  ];

  orderTableColumns.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return orderTableColumns;
}
